import React from "react";
import { Modal, Form, Select , Input, Button } from "antd";
import {
  createHealthIssue, updateHealthIssue,
} from "../../store/healthIssueSlice";
import { useDispatch, useSelector } from "react-redux";
import { API_BASE_URL } from "../../config";

const StudentHealthIssueForm = ({
  open,
  onCancel,
  onSave,
  initialValues,
  onSaveFail,
  mode,
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const storedUser = localStorage.getItem("userInfo");
  const userData = storedUser ? JSON.parse(storedUser) : null;
  const storedToken = localStorage.getItem("token");
  if (mode === "create") {
    initialValues = {
      issueType: "", 
      issueName: "", 
    };
  }
  if (!userData || !storedToken) {
    throw new Error("No user data or token found");
  }
const { Option } = Select;

  const studentId = userData.studentIds?.[0];
  console.log("userData", userData);
  console.log("initialValues", initialValues);
  console.log("initialValues", initialValues.healthID);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      console.log("values", values);
      console.log("studentId", studentId);
      const issueId = initialValues.issueId;
      const action = mode === "create" ? createHealthIssue : updateHealthIssue;

       console.log("mode", mode);
     // Dispatch action with studentId and form data
      const resultAction = await dispatch(
        action({ studentId, issueId, healthData : values })
      );
      if (action.fulfilled.match(resultAction)) {
        onSave();
      } else if (action.rejected.match(resultAction)) {
        // Show the error message returned from the backend
        onSaveFail(action.error || "Failed to submit data");
      }
      // Call the onSave function to refresh data and close the modal
    } catch (error) {
      onSaveFail(error.message || "Failed to submit data");
    }
  };

  return (
    <Modal
      title={mode === "create" ? "Add Health Issue" : "Edit Health Issue"}
      visible={open}
      onCancel={onCancel}
      footer={null}
    >
      <Form form={form} initialValues={initialValues} layout="vertical">
        <Form.Item
          name="issueID"
          label="Issue ID"
        >
          <Input disabled />
        </Form.Item>

        <Form.Item
          name="issueType"
          label="Issue Type"
          rules={[{ required: true, message: "Please select the issue type!" }]}
        >
          <Select placeholder="Select an issue type">
            <Option value="Neurological">Neurological</Option>
            <Option value="Allergy">Allergy</Option>
            <Option value="Chronic">Chronic</Option>
            <Option value="Respiratory ">Respiratory </Option>
            <Option value="Gastrointestinal  ">Gastrointestinal </Option>
            {/* Add more options as needed */}
          </Select>
        </Form.Item>

        <Form.Item
          name="issueName"
          label="Issue name"
          rules={[
            { required: true, message: "Please input the hospital number!" },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item>
          <Button type="primary" onClick={handleOk}>
            {mode === "create" ? "Add" : "Save"}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default StudentHealthIssueForm;
